import { useState, useEffect } from 'react';

/**
 * Hook for responsive design - checks if media query matches
 * @param query CSS media query string (e.g., "(max-width: 768px)")
 * @returns boolean indicating if query matches
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    // Only run on client side
    if (typeof window === 'undefined') return;

    const mediaQuery = window.matchMedia(query);

    // Set initial value
    setMatches(mediaQuery.matches);

    // Create listener
    const listener = (e: MediaQueryListEvent) => {
      setMatches(e.matches);
    };

    // Add listener
    if (mediaQuery.addListener) {
      mediaQuery.addListener(listener);
    } else {
      mediaQuery.addEventListener('change', listener);
    }

    // Cleanup
    return () => {
      if (mediaQuery.removeListener) {
        mediaQuery.removeListener(listener);
      } else {
        mediaQuery.removeEventListener('change', listener);
      }
    };
  }, [query]);

  return matches;
}
